import React from 'react';
import { MultiSelect } from 'react-multi-select-component';
import { FormGroup } from 'react-bootstrap';
import { isBoolean } from 'lodash';

export function Label(props) {
  const { placeHolder, rowIndex, colIndex, onChange, labelColours, CustomAddEditAccess, isProductArchived } = props;
  const filterData = labelColours?.filter((ele) => ele.isLabelColourChecked);

  const optionsData = filterData.map((item) => {
    return {
      label: item.colourName,
      value: item.colourHexCode,
    };
  });

  return (
    <FormGroup className="flex-fill position-relative select-min-height mb-0 mr-0">
      <div className="custom-react-select-po">
        <MultiSelect
          options={optionsData}
          className="product-custom-multiselect common-new-multiselect w-100"
          value={props?.value || []}
          labelledBy={placeHolder}
          disabled={(isBoolean(CustomAddEditAccess) ? !CustomAddEditAccess : false) || isProductArchived}
          overrideStrings={{
            selectSomeItems: placeHolder,
          }}
          onChange={(e) => onChange(e, rowIndex, colIndex)}
        />
      </div>
    </FormGroup>
  );
}
export default Label;
